import playStoreBadge from "./play-store-badge.png?url"

export default {
  src: playStoreBadge,
  width: 270,
  height: 80,
}